import React, { PropsWithChildren } from 'react';
import * as AppConstants from '@/utilities/AppConstants';
import Constants from 'expo-constants';
import { SafeAreaView } from 'react-native-safe-area-context';

interface Props {
};

let shouldAddSafeAreaView = false;
if (Constants.deviceName) {
  const deviceName = Constants.deviceName.toLowerCase();
  if (deviceName.indexOf("motorola edge") != -1 && deviceName.indexOf("2022") != -1) {
    shouldAddSafeAreaView = true;
  }
}

export function CustomSafeAreaView({ children }: PropsWithChildren<Props>) : React.ReactNode {
  if (!shouldAddSafeAreaView) {
    return (
      <>
        { children }
      </>
    );
  } else {
    return (
      <SafeAreaView style={AppConstants.STYLES.flex1} edges={["bottom"]}>
        { children }
      </SafeAreaView>
    );
  }
};
